import React, { Component } from "react";
import {
  message,
  PageHeader,
  Spin,
  Row,
  Col,
  Select,
  Checkbox,
  Space,
  Switch,
  Typography,
  Tag,
  Tooltip
} from "antd";
import {
  dineroDisabledMask,
  Form,
  FormItem,
  InputNumberItem,
  SelectItem,
  DatePickerItem,
  round2Decimals,
  ModalItem,
  ButtonItem,
  InputItem,
  NotificacionPolizas,
  NotificacionMovimientosInventario,
  round6Decimals,
  ErrorItem,
  SelectInsumosItem
} from "../../../../Components/Items";
import GeneralFormLayout from "../../../../Components/GeneralFormLayout";
import axios from "axios";
import moment from "moment";
import "moment/locale/es";
import { connect } from "react-redux";
import {
  PlusOutlined,
  SplitCellsOutlined,
  DeleteOutlined,
  DatabaseOutlined,
  TagsOutlined
} from "@ant-design/icons";
import ElegirTipoDeProveedor from "../../Proveedores/ElegirTipoDeProveedor/ElegirTipoDeProveedor";
import AgregarMarbetes from "../../Marbetes/AgregarMarbetes/AgregarMarbetes";
import AgregarLotes from "../../LotesCaducidades/AgregarLotes/AgregarLotes";
import InsumoDetalleRow from "../../../../Components/InsumoDetalleRow";
import ModalSplitInsumo from "../ModalSplitPartida/ModalSplitPartida";
import AsignarInsumo from "../../OrdenesDeCompras/AsginarInsumo/AsignarInsumo";

const { Option } = Select;

moment.locale("es");

function calcularTotalesInsumo(insumoRow, proveedor) {
  const insumo = insumoRow.insumoCompleto;
  if (!insumo) return insumoRow;

  const precioUnitario = Number(insumoRow.precioUnitario || 0);
  const cantidad = insumoRow.cantidad;
  const descuento = insumoRow.descuento || 0;

  let totalImpuestosPrecioSinImpuestos = 0;
  for (const imp of insumo.impuestos) {
    let t = 0;
    if (imp.tasaCuota === 1) t = precioUnitario * (imp.monto / 100);
    else if (imp.tasaCuota === 2) t = (precioUnitario + totalImpuestosPrecioSinImpuestos) * (imp.monto / 100);
    else if (imp.tasaCuota === 3) t = imp.monto;
    else if (imp.tasaCuota === 4) t = cantidad ? (insumoRow.impuestos || 0) / cantidad : 0;
    // tasaCuota 5 = 0
    totalImpuestosPrecioSinImpuestos += t;
  }
  const precioUnitarioConImpuestos = round2Decimals(precioUnitario + totalImpuestosPrecioSinImpuestos);

  if (!((precioUnitario || precioUnitario === 0) && cantidad)) {
    return { ...insumoRow, precioUnitarioConImpuestos };
  }

  const subtotalBruto = round6Decimals(cantidad * precioUnitario);
  const totalDescuento = round6Decimals(subtotalBruto * (descuento / 100));
  const totalEntrada = round6Decimals(subtotalBruto - totalDescuento);

  let totalImpuestos = 0;
  const arrayImpuestos = insumo.impuestos.map((imp) => {
    let t = 0;
    if (imp.tasaCuota === 1) t = round6Decimals(totalEntrada * (imp.monto / 100));
    else if (imp.tasaCuota === 2) t = round6Decimals((totalEntrada + totalImpuestos) * (imp.monto / 100));
    else if (imp.tasaCuota === 3) t = round6Decimals(cantidad * imp.monto);
    else if (imp.tasaCuota === 4) t = round6Decimals(insumoRow.impuestos || 0);
    // tasaCuota 5 = 0
    totalImpuestos += t;
    return { descripcionFactura: imp.descripcionFactura, totalImpuestos: t };
  });

  const total = round2Decimals(totalEntrada + totalImpuestos);

  // Retenciones
  let totalRetenciones = 0;
  const arrayRetenciones = [];

  if (proveedor) {
    const procesarRetencion = (ret, condicion = true) => {
      if (!condicion) return;
      let t = 0;
      if (ret.tasaCuota === 1) t = round6Decimals(totalEntrada * (ret.monto / 100));
      else if (ret.tasaCuota === 2) t = round6Decimals((totalEntrada + totalRetenciones) * (ret.monto / 100));
      totalRetenciones += t;
      arrayRetenciones.push({ descripcionFactura: ret.descripcionFactura, totalRetenciones: t });
    };

    for (const ret of (proveedor.retenciones || [])) {
      procesarRetencion(ret);
    }
    for (const ret of (insumo.retenciones || [])) {
      const aplica =
        (ret.aplicaCompra === 1 && !proveedor.persona) ||
        (ret.aplicaCompra === 2 && proveedor.persona) ||
        ret.aplicaCompra === 3;
      procesarRetencion(ret, aplica);
    }
  }

  return {
    ...insumoRow,
    precioUnitarioConImpuestos,
    subtotal: totalEntrada,
    impuestos: totalImpuestos,
    arrayImpuestos,
    total,
    retenciones: totalRetenciones,
    arrayRetenciones,
  };
}

class AgregarRemision extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    objetoProveedores: null,
    todasProveedores: null,
    objetoProyectos: null,
    todasProyectos: null,
    objetoInsumos: (
      <Option disabled value={0} key={0}>
        Seleccione un proveedor primero
      </Option>
    ),
    //todasInsumos: [],
    objetoMonedas: null,
    todasMonedas: null,
    impuestos: [],
    modalConfirmacion: false,
    valuesForm: null,
    modalElegirTipoDeProveedor: false,
    modalElegirTipoDeProveedorId: null,
    modalElegirTipoDeProveedorNombre: null,
    rendered: 0,
    ajusteMax: 0,
    modalAgregarMarbetes: false,
    modalAgregarMarbetesIndex: null,
    modalAgregarMarbetesMarbetes: null,
    recibirInsumos: true,
    mostrarDetalles: true,
    modalAgregarLotes: false,
    modalAgregarLotesIndex: null,
    modalAgregarLotesLotes: null,
    modalAgregarLotesVehiculo: false,
    modalAgregarLotesInsumoId : null,
    modalAsignarInsumoVisible: false,
    proveedorSeleccionado: null,
  };
  async componentDidMount() {
    this.setState({ loading: true });
    await this.consultarTodo();
    this.setState({ loading: false });
  }

  promisedSetState = (newState) =>
    new Promise((resolve) => this.setState(newState, resolve));

  async consultarTodo() {
    const responseConfiguracion = axios.post(
      "empresas/selectConfiguracionGeneralParaFacturas",
      { empresaId: this.props.empresaId },
      { headers: this.props.headersToken }
    );

    const responseProveedores = axios.post(
      "proveedores/selectProveedores",
      { empresaId: this.props.empresaId },
      {
        headers: this.props.headersToken,
      }
    );

    const responseProyectos = axios.post(
      "proyectos/selectProyectos",
      { empresaId: this.props.empresaId },
      {
        headers: this.props.headersToken,
      }
    );

    const responseMonedas = axios.post(
      "monedas/selectMonedas",
      { empresaId: this.props.empresaId },
      {
        headers: this.props.headersToken,
      }
    );

    const responses = await Promise.all([
      responseConfiguracion,
      responseProveedores,
      responseProyectos,
      responseMonedas,
    ]);

    let newState = {};

    if (responses[0].data.status === 404) {
      message.error("Error no se encontro configuracion de esta empresa");
    } else {
      newState.empresaRfc = responses[0].data.rfc;
      newState.ajusteMax = responses[0].data.ajusteMax;
    }

    if (responses[1].data.status === 404) {
    } else {
      newState.todasProveedores = responses[1].data;
      newState.objetoProveedores = responses[1].data.map((value) => {
        return (
          <Option value={value._id} key={value._id}>
            {value.stringBuscar}
          </Option>
        );
      });
    }

    if (responses[2].data.status === 404) {
    } else {
      newState.todasProyectos = responses[2].data;
      newState.objetoProyectos = responses[2].data.map((value) => {
        return (
          <Option value={value._id} key={value._id}>
            {value.nombre}
          </Option>
        );
      });
    }

    if (responses[3].data.status === 404) {
    } else {
      newState.todasMonedas = responses[3].data;
      newState.objetoMonedas = responses[3].data.map((value) => {
        return (
          <Option value={value._id} key={value._id}>
            {value.nombre + " - " + value.abreviacion}
          </Option>
        );
      });
    }

    await this.promisedSetState(newState);
  }
  onFinishFailed(e) {
    ErrorItem(e);
  }
  onFinish(values) {
    this.setState({ loading: true });
    let insumos = values.insumos;
    let total = 0;
    let subtotal = 0;
    let arrayImpuestos = [];
    let arrayRetenciones = [];
    let cuentasProveedor = 0;
    insumos.map((value) => {
      total += value.subtotal;
      subtotal += value.subtotal;
      value.arrayImpuestos.map((valueImpuestos) => {
        let index = arrayImpuestos.findIndex(
          (valueImpuestosAnterios) =>
            valueImpuestosAnterios.descripcionFactura ===
            valueImpuestos.descripcionFactura
        );
        if (index !== -1) {
          let newItem = {
            totalImpuestos:
              arrayImpuestos[index].totalImpuestos +
              valueImpuestos.totalImpuestos,
            descripcionFactura: valueImpuestos.descripcionFactura,
          };
          arrayImpuestos.splice(index, 1, newItem);
        } else {
          arrayImpuestos.push({
            totalImpuestos: valueImpuestos.totalImpuestos,
            descripcionFactura: valueImpuestos.descripcionFactura,
          });
        }
        return null;
      });
      if (value.arrayRetenciones) {
        value.arrayRetenciones.map((valueRetenciones) => {
          let index = arrayRetenciones.findIndex(
            (valueRetencionesAnterios) =>
              valueRetencionesAnterios.descripcionFactura ===
              valueRetenciones.descripcionFactura
          );
          cuentasProveedor += round2Decimals(valueRetenciones.totalRetenciones);
          if (index !== -1) {
            let newItem = {
              totalRetenciones:
                arrayRetenciones[index].totalRetenciones +
                valueRetenciones.totalRetenciones,
              descripcionFactura: valueRetenciones.descripcionFactura,
            };
            arrayRetenciones.splice(index, 1, newItem);
          } else {
            arrayRetenciones.push({
              totalRetenciones: valueRetenciones.totalRetenciones,
              descripcionFactura: valueRetenciones.descripcionFactura,
            });
          }
          return null;
        });
      }
      return null;
    });
     subtotal += values.ajusteSubtotal;
    total += values.ajusteSubtotal;
    arrayImpuestos = arrayImpuestos.map((valueImpuesto) => {
      let ajusteImpuesto = values["ajuste" + valueImpuesto.descripcionFactura] || 0;
      total += round2Decimals(valueImpuesto.totalImpuestos + ajusteImpuesto);
      return {
        ...valueImpuesto,
        ajusteImpuesto,
        totalImpuestos: round2Decimals(
          valueImpuesto.totalImpuestos + ajusteImpuesto
        ),
      };
    });
    arrayRetenciones = arrayRetenciones.map((valueRetencion) => {
      let ajusteRetencion =
        values["ajuste" + valueRetencion.descripcionFactura] || 0;
      cuentasProveedor += ajusteRetencion;
      return {
        ...valueRetencion,
        ajusteRetencion,
        totalRetenciones: valueRetencion.totalRetenciones + ajusteRetencion,
      };
    });
    axios
      .post(
        "remisiones/agregarRemision",
        {
          ...values,
          empresaId: this.props.empresaId,
          total: round2Decimals(total),
          subtotal: round2Decimals(subtotal),
          cuentasProveedor: round2Decimals(cuentasProveedor),
          totalPagar: round2Decimals(total - cuentasProveedor),
          arrayImpuestos,
          arrayRetenciones,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Se ha registrado una remisión");
          NotificacionPolizas(res.data.polizasId);
          NotificacionMovimientosInventario(res.data.movimientosIds);
          this.formRef.current.resetFields();
          this.atras(res.data.codigo);
        } else if (res.data.success === 1) {
          message.warning(res.data.message);
        } else {
          message.error("Hubo un error y la remisión no se registró");
        }
      });
  }

  async onChangeInsumo(value, key, insumoSeleccionado) {
    if (!insumoSeleccionado) return;
    let arrayValue = await this.formRef.current.getFieldValue("insumos");
    let proveedorId = await this.formRef.current.getFieldValue("proveedorId");
    /*
    const proveedor = this.state.todasProveedores?.find(p => p._id === proveedorId);

    arrayValue[key] = {
      ...arrayValue[key],
      insumoCompleto: insumoSeleccionado,
      precioUnitario: insumoSeleccionado.costo,
      codigo: insumoSeleccionado.codigo,
      unidad: insumoSeleccionado.unidad,
    };

    arrayValue[key] = calcularTotalesInsumo(arrayValue[key], proveedor);

    this.formRef.current.setFieldsValue({ insumos: arrayValue })
    */
    const insumo = insumoSeleccionado; 

    if (!insumo) return;
    arrayValue[key].insumoCompleto = insumo; 
    arrayValue[key].precioUnitario = insumo.costo;
    arrayValue[key].codigo = insumo.codigo;
    arrayValue[key].unidad = insumo.unidad;
    const precioUnitario = Number(arrayValue[key].precioUnitario);

    let totalImpuestosPrecioSinImpuestos = 0;
    insumo.impuestos.map((valueImpuesto) => {
      let totalImpuesto;
      if (valueImpuesto.tasaCuota === 1) {
        totalImpuesto = precioUnitario * (valueImpuesto.monto / 100);
      } else if (valueImpuesto.tasaCuota === 2) {
        totalImpuesto =
          (precioUnitario + totalImpuestosPrecioSinImpuestos) *
          (valueImpuesto.monto / 100);
      } else if (valueImpuesto.tasaCuota === 3) {
        totalImpuesto = valueImpuesto.monto;
      } else if (valueImpuesto.tasaCuota === 4) {
        let cantidad = arrayValue[key].cantidad;
        if (cantidad) {
          totalImpuesto =
            (arrayValue[key].impuestos || 0) / arrayValue[key].cantidad;
        }
      } else if (valueImpuesto.tasaCuota === 5) {
        totalImpuesto = 0;
      }
      totalImpuestosPrecioSinImpuestos += totalImpuesto;
      return null;
    });
    arrayValue[key].precioUnitarioConImpuestos = round2Decimals(
      precioUnitario + totalImpuestosPrecioSinImpuestos
    );

    const cantidad = arrayValue[key].cantidad;
    const descuento = arrayValue[key].descuento || 0;

    if ((precioUnitario || precioUnitario === 0) && cantidad && insumo) {
      //1
      const subtotal = round6Decimals(cantidad * precioUnitario);
      //2
      const totalDescuento = round6Decimals(subtotal * (descuento / 100));
      //3
      const totalEntrada = round6Decimals(subtotal - totalDescuento);
      arrayValue[key].subtotal = totalEntrada;

      let totalImpuestos = 0;
      let arrayImpuestos = insumo.impuestos.map(
        //4
        (valueImpuesto) => {
          let totalImpuesto;
          if (valueImpuesto.tasaCuota === 1) {
            totalImpuesto = round6Decimals(
              totalEntrada * (valueImpuesto.monto / 100)
            );
          } else if (valueImpuesto.tasaCuota === 2) {
            totalImpuesto = round6Decimals(
              (totalEntrada + totalImpuestos) * (valueImpuesto.monto / 100)
            );
          } else if (valueImpuesto.tasaCuota === 3) {
            totalImpuesto = round6Decimals(cantidad * valueImpuesto.monto);
          } else if (valueImpuesto.tasaCuota === 4) {
            totalImpuesto = round6Decimals(arrayValue[key].impuestos);
          } else if (valueImpuesto.tasaCuota === 5) {
            totalImpuesto = 0;
          }
          totalImpuestos += totalImpuesto;
          return {
            descripcionFactura: valueImpuesto.descripcionFactura,
            totalImpuestos: totalImpuesto,
          };
        }
      );
      arrayValue[key].impuestos = totalImpuestos;
      arrayValue[key].arrayImpuestos = arrayImpuestos;
      //5
      const total = round2Decimals(arrayValue[key].subtotal + totalImpuestos);
      arrayValue[key].total = total;

      if (proveedorId) {
        //Consultar proveedor

        const proveedor = this.state.todasProveedores.find(
          (valueP) => valueP._id === proveedorId
        );
        //6
        let totalRetenciones = 0;
        let arrayRetenciones = [];

        proveedor.retenciones.map((valueRetencion) => {
          //7
          let totalRetencion;
          if (valueRetencion.tasaCuota === 1) {
            totalRetencion = round6Decimals(
              totalEntrada * (valueRetencion.monto / 100)
            );
          } else if (valueRetencion.tasaCuota === 2) {
            totalRetencion = round6Decimals(
              (totalEntrada + totalRetenciones) * (valueRetencion.monto / 100)
            );
          }
          totalRetenciones += totalRetencion;
          arrayRetenciones.push({
            descripcionFactura: valueRetencion.descripcionFactura,
            totalRetenciones: totalRetencion,
          });
          return null;
        });

        insumo.retenciones.map((valueRetencion) => {
          if (
            (valueRetencion.aplicaCompra === 1 &&
              proveedor.persona === false) ||
            (valueRetencion.aplicaCompra === 2 && proveedor.persona === true) ||
            valueRetencion.aplicaCompra === 3
          ) {
            //7
            let totalRetencion;
            if (valueRetencion.tasaCuota === 1) {
              totalRetencion = round6Decimals(
                totalEntrada * (valueRetencion.monto / 100)
              );
            } else if (valueRetencion.tasaCuota === 2) {
              totalRetencion = round6Decimals(
                (totalEntrada + totalRetenciones) * (valueRetencion.monto / 100)
              );
            }
            totalRetenciones += totalRetencion;
            arrayRetenciones.push({
              descripcionFactura: valueRetencion.descripcionFactura,
              totalRetenciones: totalRetencion,
            });
          }
          return null;
        });
        arrayValue[key].retenciones = totalRetenciones;
        arrayValue[key].arrayRetenciones = arrayRetenciones;
      }
    }

    this.formRef.current.setFieldsValue([
      { name: ["insumos", key, "insumoCompleto"], value: arrayValue[key].insumoCompleto },
      { name: ["insumos", key, "precioUnitario"], value: arrayValue[key].precioUnitario },
      { name: ["insumos", key, "codigo"], value: arrayValue[key].codigo },
      { name: ["insumos", key, "unidad"], value: arrayValue[key].unidad },
      { name: ["insumos", key, "precioUnitarioConImpuestos"], value: arrayValue[key].precioUnitarioConImpuestos },
      { name: ["insumos", key, "subtotal"], value: arrayValue[key].subtotal },
      { name: ["insumos", key, "impuestos"], value: arrayValue[key].impuestos },
      { name: ["insumos", key, "arrayImpuestos"], value: arrayValue[key].arrayImpuestos },
      { name: ["insumos", key, "total"], value: arrayValue[key].total },
      { name: ["insumos", key, "retenciones"], value: arrayValue[key].retenciones },
      { name: ["insumos", key, "arrayRetenciones"], value: arrayValue[key].arrayRetenciones },
    ]);
    

  }
  async onChangePrecioCantidadDescuento(checarInsumo, key) {
    let arrayValue = await this.formRef.current.getFieldValue("insumos");
    if (!arrayValue[key]?.insumoCompleto) return;
    let proveedorId = await this.formRef.current.getFieldValue("proveedorId");
    /*const proveedor = this.state.todasProveedores?.find(p => p._id === proveedorId);

    arrayValue[key] = calcularTotalesInsumo(arrayValue[key], proveedor);
    this.formRef.current.setFieldsValue({ insumos: arrayValue });*/
    
    const insumo = arrayValue[key]?.insumoCompleto;
    if (!insumo) return;
    const precioUnitario = Number(arrayValue[key].precioUnitario);

    let totalImpuestosPrecioSinImpuestos = 0;
    insumo.impuestos.map((valueImpuesto) => {
      let totalImpuesto;
      if (valueImpuesto.tasaCuota === 1) {
        totalImpuesto = precioUnitario * (valueImpuesto.monto / 100);
      } else if (valueImpuesto.tasaCuota === 2) {
        totalImpuesto =
          (precioUnitario + totalImpuestosPrecioSinImpuestos) *
          (valueImpuesto.monto / 100);
      } else if (valueImpuesto.tasaCuota === 3) {
        totalImpuesto = valueImpuesto.monto;
      } else if (valueImpuesto.tasaCuota === 4) {
        let cantidad = arrayValue[key].cantidad;
        if (cantidad) {
          totalImpuesto =
            (arrayValue[key].impuestos || 0) / arrayValue[key].cantidad;
        }
      } else if (valueImpuesto.tasaCuota === 5) {
        totalImpuesto = 0;
      }
      totalImpuestosPrecioSinImpuestos += totalImpuesto;
      return null;
    });
    arrayValue[key].precioUnitarioConImpuestos = round2Decimals(
      Number(precioUnitario) + Number(totalImpuestosPrecioSinImpuestos)
    );
    const cantidad = arrayValue[key].cantidad;
    const descuento = arrayValue[key].descuento || 0;

    if ((precioUnitario || precioUnitario === 0) && cantidad && insumo) {
      //1
      const subtotal = round6Decimals(cantidad * precioUnitario);
      //2
      const totalDescuento = round6Decimals(subtotal * (descuento / 100));
      //3
      const totalEntrada = round6Decimals(subtotal - totalDescuento);
      arrayValue[key].subtotal = totalEntrada;

      let totalImpuestos = 0;
      let arrayImpuestos = insumo.impuestos.map(
        //4
        (valueImpuesto) => {
          let totalImpuesto;
          if (valueImpuesto.tasaCuota === 1) {
            totalImpuesto = round6Decimals(
              totalEntrada * (valueImpuesto.monto / 100)
            );
          } else if (valueImpuesto.tasaCuota === 2) {
            totalImpuesto = round6Decimals(
              (totalEntrada + totalImpuestos) * (valueImpuesto.monto / 100)
            );
          } else if (valueImpuesto.tasaCuota === 3) {
            totalImpuesto = round6Decimals(cantidad * valueImpuesto.monto);
          } else if (valueImpuesto.tasaCuota === 4) {
            totalImpuesto = round6Decimals(arrayValue[key].impuestos);
          } else if (valueImpuesto.tasaCuota === 5) {
            totalImpuesto = 0;
          }
          totalImpuestos += totalImpuesto;
          return {
            descripcionFactura: valueImpuesto.descripcionFactura,
            totalImpuestos: totalImpuesto,
          };
        }
      );
      arrayValue[key].impuestos = totalImpuestos;
      arrayValue[key].arrayImpuestos = arrayImpuestos;
      //5
      const total = round2Decimals(arrayValue[key].subtotal + totalImpuestos);
      arrayValue[key].total = total;

      if (proveedorId) {
        //Consultar proveedor

        const proveedor = this.state.todasProveedores.find(
          (valueP) => valueP._id === proveedorId
        );
        //6
        let totalRetenciones = 0;
        let arrayRetenciones = [];

        proveedor.retenciones.map((valueRetencion) => {
          //7
          let totalRetencion;
          if (valueRetencion.tasaCuota === 1) {
            totalRetencion = round6Decimals(
              totalEntrada * (valueRetencion.monto / 100)
            );
          } else if (valueRetencion.tasaCuota === 2) {
            totalRetencion = round6Decimals(
              (totalEntrada + totalRetenciones) * (valueRetencion.monto / 100)
            );
          }
          totalRetenciones += totalRetencion;
          arrayRetenciones.push({
            descripcionFactura: valueRetencion.descripcionFactura,
            totalRetenciones: totalRetencion,
          });
          return null;
        });

        insumo.retenciones.map((valueRetencion) => {
          if (
            (valueRetencion.aplicaCompra === 1 &&
              proveedor.persona === false) ||
            (valueRetencion.aplicaCompra === 2 && proveedor.persona === true) ||
            valueRetencion.aplicaCompra === 3
          ) {
            //7
            let totalRetencion;
            if (valueRetencion.tasaCuota === 1) {
              totalRetencion = round6Decimals(
                totalEntrada * (valueRetencion.monto / 100)
              );
            } else if (valueRetencion.tasaCuota === 2) {
              totalRetencion = round6Decimals(
                (totalEntrada + totalRetenciones) * (valueRetencion.monto / 100)
              );
            }
            totalRetenciones += totalRetencion;
            arrayRetenciones.push({
              descripcionFactura: valueRetencion.descripcionFactura,
              totalRetenciones: totalRetencion,
            });
          }
          return null;
        });
        arrayValue[key].retenciones = totalRetenciones;
        arrayValue[key].arrayRetenciones = arrayRetenciones;
      }
    }
    this.formRef.current.setFieldsValue({

      insumos: arrayValue,

    });
    
  }


  async onChangePrecioImpuestos(value, key) {
    let arrayValue = await this.formRef.current.getFieldValue("insumos");
    let proveedorId = await this.formRef.current.getFieldValue("proveedorId");
    /*
    const proveedor = this.state.todasProveedores?.find(p => p._id === proveedorId);

    const insumo = arrayValue[key]?.insumoCompleto;
    if (!insumo) return;

    let totalPorcentaje = 1;
    let totalCantidad = 0;
    for (const imp of insumo.impuestos) {
      if (imp.tasaCuota === 1) totalPorcentaje += imp.monto / 100;
      else if (imp.tasaCuota === 2)
        totalPorcentaje += totalPorcentaje * (imp.monto / 100);
      else if (imp.tasaCuota === 3) totalCantidad = imp.monto;
    }
    arrayValue[key].precioUnitario =
      arrayValue[key].precioUnitarioConImpuestos / totalPorcentaje +
      totalCantidad;

    arrayValue[key] = calcularTotalesInsumo(arrayValue[key], proveedor);
    this.formRef.current.setFieldsValue({ insumos: arrayValue });
    */
    const insumo = arrayValue[key]?.insumoCompleto;
    if (!insumo) return;

    const precioUnitarioConImpuestos =
      arrayValue[key].precioUnitarioConImpuestos;

    let totalPorcentajeImpuestos = 1;
    let totalCantidadImpuestos = 0;
    insumo.impuestos.map((valueImpuesto) => {
      if (valueImpuesto.tasaCuota === 1) {
        totalPorcentajeImpuestos += valueImpuesto.monto / 100;
      } else if (valueImpuesto.tasaCuota === 2) {
        totalPorcentajeImpuestos +=
          totalPorcentajeImpuestos * (valueImpuesto.monto / 100);
      } else if (valueImpuesto.tasaCuota === 3) {
        totalCantidadImpuestos = valueImpuesto.monto;
      }
      return null;
    });

    const precioUnitario =
      precioUnitarioConImpuestos / totalPorcentajeImpuestos +
      totalCantidadImpuestos;
    arrayValue[key].precioUnitario = precioUnitario;
    const cantidad = arrayValue[key].cantidad;
    const descuento = arrayValue[key].descuento || 0;

    if ((precioUnitario || precioUnitario === 0) && cantidad && insumo) {
      //1
      const subtotal = round6Decimals(cantidad * precioUnitario);
      //2
      const totalDescuento = round6Decimals(subtotal * (descuento / 100));
      //3
      const totalEntrada = round6Decimals(subtotal - totalDescuento);
      arrayValue[key].subtotal = totalEntrada;

      let totalImpuestos = 0;
      let arrayImpuestos = insumo.impuestos.map(
        //4
        (valueImpuesto) => {
          let totalImpuesto;
          if (valueImpuesto.tasaCuota === 1) {
            totalImpuesto = round6Decimals(
              totalEntrada * (valueImpuesto.monto / 100)
            );
          } else if (valueImpuesto.tasaCuota === 2) {
            totalImpuesto = round6Decimals(
              (totalEntrada + totalImpuestos) * (valueImpuesto.monto / 100)
            );
          } else if (valueImpuesto.tasaCuota === 3) {
            totalImpuesto = round6Decimals(cantidad * valueImpuesto.monto);
          } else if (valueImpuesto.tasaCuota === 4) {
            totalImpuesto = round6Decimals(arrayValue[key].impuestos);
          } else if (valueImpuesto.tasaCuota === 5) {
            totalImpuesto = 0;
          }
          totalImpuestos += totalImpuesto;
          return {
            descripcionFactura: valueImpuesto.descripcionFactura,
            totalImpuestos: totalImpuesto,
          };
        }
      );
      arrayValue[key].impuestos = totalImpuestos;
      arrayValue[key].arrayImpuestos = arrayImpuestos;
      //5
      const total = round2Decimals(arrayValue[key].subtotal + totalImpuestos);
      arrayValue[key].total = total;

      if (proveedorId) {
        //Consultar proveedor

        const proveedor = this.state.todasProveedores.find(
          (valueP) => valueP._id === proveedorId
        );
        //6
        let totalRetenciones = 0;
        let arrayRetenciones = [];

        proveedor.retenciones.map((valueRetencion) => {
          //7
          let totalRetencion;
          if (valueRetencion.tasaCuota === 1) {
            totalRetencion = round6Decimals(
              totalEntrada * (valueRetencion.monto / 100)
            );
          } else if (valueRetencion.tasaCuota === 2) {
            totalRetencion = round6Decimals(
              (totalEntrada + totalRetenciones) * (valueRetencion.monto / 100)
            );
          }
          totalRetenciones += totalRetencion;
          arrayRetenciones.push({
            descripcionFactura: valueRetencion.descripcionFactura,
            totalRetenciones: totalRetencion,
          });
          return null;
        });

        insumo.retenciones.map((valueRetencion) => {
          if (
            (valueRetencion.aplicaCompra === 1 &&
              proveedor.persona === false) ||
            (valueRetencion.aplicaCompra === 2 && proveedor.persona === true) ||
            valueRetencion.aplicaCompra === 3
          ) {
            //7
            let totalRetencion;
            if (valueRetencion.tasaCuota === 1) {
              totalRetencion = round6Decimals(
                totalEntrada * (valueRetencion.monto / 100)
              );
            } else if (valueRetencion.tasaCuota === 2) {
              totalRetencion = round6Decimals(
                (totalEntrada + totalRetenciones) * (valueRetencion.monto / 100)
              );
            }
            totalRetenciones += totalRetencion;
            arrayRetenciones.push({
              descripcionFactura: valueRetencion.descripcionFactura,
              totalRetenciones: totalRetencion,
            });
          }
          return null;
        });
        arrayValue[key].retenciones = totalRetenciones;
        arrayValue[key].arrayRetenciones = arrayRetenciones;
      }
    }
   this.formRef.current.setFieldsValue({
      insumos: arrayValue,
    });
    
  }

  async onChangeProveedor(value, _, dejarInsumos) {
    const proveedor = this.state.todasProveedores.find(
      (valueProv) => valueProv._id === value
    );
    if (!proveedor.tipoProveedorId) {
      const nombre = proveedor.persona
        ? proveedor.razonSocial
        : `${proveedor.nombre} ${proveedor.apellidoPaterno} ${proveedor.apellidoMaterno}`;
      this.abrirElegirTipoDeProveedor(proveedor._id, nombre);
    }
    const fechaRemision = await this.formRef.current.getFieldValue(
      "fechaRemision"
    );
    let arrayValue = await this.formRef.current.getFieldValue("insumos");
    this.formRef.current.setFieldsValue({
      insumos: dejarInsumos ? arrayValue : [],
      fechaPago: moment(fechaRemision).add(proveedor.diasCredito, "days"),
      diasCredito: proveedor.diasCredito || 0,
    });
    //await this.consultarInsumoProveedor(value);

    //Borrar insumos que no sean del proveedor !!!!!!!!!!!!!!!!!!!!!!!!!IMPORTANTE

    // for (const [key, valueInsumo] of arrayValue.entries()) {
    //   const insumo = this.state.todasInsumos.find(
    //     (valueInsumos) => valueInsumos._id === valueInsumo?.insumoId
    //   );

    //   console.log(!insumo, valueInsumo?.insumoId)

    //   if(!insumo && valueInsumo?.insumoId){
    //     arrayValue.splice(key, 1)
    //   }
    //   console.log(arrayValue)
    // }
    this.setState({ loading: false , proveedorId: value, proveedorSeleccionado: proveedor });
  }

  abrirModalAsignarInsumo = () => {
    this.setState({ modalAsignarInsumoVisible: true });
  };

  cerrarModalAsignarInsumo = () => {
    this.setState({ modalAsignarInsumoVisible: false });
  };

  async recargarInsumoEditado(proveedorId, insumoId, arrayKey) {
    this.setState({ loading: true });
    try {
      const res = await axios.post(
        "insumos/selectInsumosRelacionesProveedor",
        {
          empresaId: this.props.empresaId,
          proveedorId: proveedorId,
          query: insumoId, 
          skip: 0
        },
        { headers: this.props.headersToken }
      );

      if (res.data.success === 2 && res.data.insumos && res.data.insumos.length > 0) {
        const insumoFresco = res.data.insumos[0];
        
        let arrayValue = this.formRef.current.getFieldValue("insumos");
        
        arrayValue[arrayKey].insumoCompleto = insumoFresco;
        
        arrayValue[arrayKey].precioUnitario = insumoFresco.costo || arrayValue[arrayKey].precioUnitario;
        
        this.formRef.current.setFieldsValue({ insumos: arrayValue });
        
        await this.onChangePrecioCantidadDescuento(undefined, arrayKey);
      }
    } catch (error) {
      console.error("Error recargando el insumo modificado:", error);
    } finally {
      this.setState({ loading: false });
    }
  }
  

  atras() {
    this.props.history.push("/panel/remisiones");
  }
  async actualizarBoton() {
    await this.consultarTodo();
    let arrayValue = this.formRef.current.getFieldValue("insumos");
    if (arrayValue?.length > 0) {
      arrayValue.map((valueInsumo, key) =>
        this.onChangePrecioCantidadDescuento(undefined, key)
      );
    }
  }
  abrirElegirTipoDeProveedor(id, nombre) {
    this.setState({
      modalElegirTipoDeProveedor: true,
      modalElegirTipoDeProveedorId: id,
      modalElegirTipoDeProveedorNombre: nombre,
    });
  }
  cerrarElegirTipoDeProveedor(elegido) {
    if (!elegido) {
      this.formRef.current.setFieldsValue({ proveedorId: undefined });
    }
    this.consultarTodo();
    this.setState({
      modalElegirTipoDeProveedor: false,
      modalElegirTipoDeProveedorId: null,
      modalElegirTipoDeProveedorNombre: null,
    });
  }
  

  abrirAgregarMarbetes(value, marbetes) {
    this.setState({
      modalAgregarMarbetes: true,
      modalAgregarMarbetesIndex: value,
      modalAgregarMarbetesMarbetes: marbetes,
    });
  }

  cerrarAgregarMarbetes(value) {
    const insumos = this.formRef.current.getFieldValue("insumos");
    insumos[this.state.modalAgregarMarbetesIndex].marbetes = value;
    this.formRef.current.setFieldsValue({
      insumos: insumos,
    });
    this.setState({
      modalAgregarMarbetes: false,
      modalAgregarMarbetesIndex: null,
      modalAgregarMarbetesMarbetes: null,
    });
  }

  abrirAgregarLotes(value, lotes, vehiculo, insumoId) {
    this.setState({
      modalAgregarLotes: true,
      modalAgregarLotesIndex: value,
      modalAgregarLotesLotes: lotes,
      modalAgregarLotesVehiculo: vehiculo,
      modalAgregarLotesInsumoId : insumoId, 
    });
  }

  cerrarAgregarLotes(value) {
    const insumos = this.formRef.current.getFieldValue("insumos");
    insumos[this.state.modalAgregarLotesIndex].lotes = value;
    this.formRef.current.setFieldsValue({
      insumos: insumos,
    });
    this.setState({
      modalAgregarLotes: false,
      modalAgregarLotesIndex: null,
      modalAgregarLotesLotes: null,
       modalAgregarLotesVehiculo: false,
      modalAgregarLotesInsumoId : null, 
    });
  }

  onChangeProyecto(value) {
    const insumos = this.formRef.current.getFieldValue("insumos");
    const proyecto = this.state.todasProyectos?.find(
      (valueP) => valueP._id === value
    );

    if (
      proyecto &&
      Array.isArray(proyecto.subProyectos) &&
      proyecto?.subProyectos?.length > 0
    ) {
      this.setState({
        proyectosConSubproyectos: true,
        objetoSubproyectos: proyecto.subProyectos.map((value) => (
          <Option key={value._id} value={value._id}>
            {value.codigo + " - " +value.nombre}
          </Option>
        )),
      });
    }

    if (Array.isArray(insumos) && insumos.length > 0) {
      const nuevosInsumos = insumos.map((insumo) => {
        if (!insumo.proyectoId) {
          insumo.proyectoId = value;
        }
        return insumo;
      });
      this.formRef.current.setFieldsValue({
        insumos: nuevosInsumos,
      });
    }
  }

  abrirSplitInsumo = (index) => {
    const insumos = this.formRef.current.getFieldValue("insumos") || [];
    const original = insumos[index];

    const cantidadOriginal = Number(original?.cantidad || 0);

    if (!cantidadOriginal || cantidadOriginal <= 0) {
      message.warning("Primero captura una cantidad para poder hacer el split.");
      return;
    }

    const insumo = insumos[index]?.insumoCompleto; 

    if (!insumo) {
      message.error("No se encontró el insumo a dividir.");
      return;
    }

    this.setState({
      modalSplitVisible: true,
      modalSplitIndex: index,
      modalSplitInsumo: insumo,
      modalSplitCantidad: cantidadOriginal,
    });
  };

  cerrarSplitInsumo = () => {
    this.setState({
      modalSplitVisible: false,
      modalSplitIndex: null,
      modalSplitCantidad: 0,
      modalSplitInsumo: null,
    });
  };

  confirmarSplitInsumo = (partidas) => {
    const { modalSplitCantidad, modalSplitIndex } = this.state;

    if (!Array.isArray(partidas) || partidas.length < 2) {
      message.error("Debes capturar al menos 2 partidas.");
      return;
    }

    const totalSplit = partidas.reduce(
      (acc, p) => acc + (Number(p.cantidad) || 0),
      0
    );

    if (totalSplit !== modalSplitCantidad) {
      message.error(
        `La suma de las cantidades (${totalSplit}) debe ser IGUAL a la cantidad original (${modalSplitCantidad}).`
      );
      return;
    }

    const insumos = this.formRef.current.getFieldValue("insumos") || [];
    const original = insumos[modalSplitIndex];

    if (!original) {
      message.error("No se encontró el insumo a dividir.");
      return;
    }

    // Crear nuevas líneas a partir del original
    const nuevasLineas = partidas.map((p) => ({
      ...original,
      proyectoId: p.proyectoId || original.proyectoId,
      subProyectoId: p.subProyectoId || original.subProyectoId,
      cantidad: Number(p.cantidad) || 0,
    }));

    // Reemplazar la línea original por las nuevas
    const nuevosInsumos = [...insumos];
    nuevosInsumos.splice(modalSplitIndex, 1, ...nuevasLineas);

    this.formRef.current.setFieldsValue({ insumos: nuevosInsumos });

    // Recalcular cada nueva línea con tu función actual
    /*
    nuevasLineas.forEach((linea, idxLocal) => {
      const idxGlobal = modalSplitIndex + idxLocal;
      this.onChangePrecioCantidadDescuento(linea.cantidad, idxGlobal);
    });*/

    const proveedorId = this.formRef.current.getFieldValue("proveedorId");
    const proveedor = this.state.todasProveedores?.find(p => p._id === proveedorId);
    const insumosRecalculados = nuevosInsumos.map((insumoRow) =>
      calcularTotalesInsumo(insumoRow, proveedor)
    );
    this.formRef.current.setFieldsValue({ insumos: insumosRecalculados });

    this.cerrarSplitInsumo();
  };

  getInsumosColumns() {
    return [
      { title: "Clave",  width: "5%"  },
      { title: "Insumo", width: "19%" },
      { title: "Unidad", width: "5%"  },
      { title: "Proyecto", width: "9%"  },
      { title: "Subp.",  width: "7%"  },
      { title: "P.U.",   width: "8%"  },
      { title: "P.U. c/Imp.",  width: "10%"  },
      { title: "Cant.", width: "7%"  },
      { title: "Desc.", width: "7%"  },
      { title: "Subtotal / Imp. / Total", width: "13%" },
      { title: "Acción", width: "8%"  },
    ];
  }

  renderInsumoRow({ key, name, fieldKey, restField, arrayKey, remove, formInstance }) {
    const insumos = this.formRef.current.getFieldValue("insumos");

    return (
      <React.Fragment key={key}>
        <tr>
          {/* Clave */}
          <td className="td-border">
            <FormItem noStyle shouldUpdate>
              {({ getFieldValue }) => {
                const arrayValue = getFieldValue("insumos");
                const clave = arrayValue[arrayKey]?.insumoCompleto?.clave;
                return clave ? (
                  <Tooltip title={clave} placement="top">
                    <span style={{ fontSize: "12px", color: "#555", display: "block", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{clave}</span>
                  </Tooltip>
                ) : (
                  <span style={{ fontSize: "12px", color: "#555" }}>{""}</span>
                );
              }}
            </FormItem>
          </td>
          {/* Insumo */}
          <td className="td-border">
            <FormItem
              {...restField}
              name={[name, "insumoId"]}
              fieldKey={[arrayKey, "insumoId"]}
              required
              noStyle
            >
              <SelectInsumosItem
                empresaId={this.props.empresaId}
                headersToken={this.props.headersToken}
                sinBorde
                width="100%"
                dropdownMatchSelectWidth={600}
                placeholder="Insumo"
                tiposInsumos="ordenDeCompra"
                proveedorId={this.state.proveedorId}
                ocultarCodigoYUnidad
                onChange={(value, insumo) => this.onChangeInsumo(value, arrayKey, insumo)}
                insumoPreCargado={insumos ? insumos[arrayKey]?.insumoCompleto : null}
              />
            </FormItem>

          </td>

          <td className="td-border">
              <FormItem noStyle shouldUpdate>
                {({ getFieldValue }) => {
                  const insumo = getFieldValue(['insumos', arrayKey, 'insumoCompleto']);
                  return (
                    <div style={{ fontSize: '14px', textAlign: 'center', color: '#868585' }}>
                      {insumo?.unidad || '-'}
                    </div>
                  );
                }}
              </FormItem>
          </td>
          {/* Proyecto */}
          <td className="td-border">
            <FormItem
              {...restField}
              name={[name, "proyectoId"]}
              fieldKey={[arrayKey, "proyectoId"]}
              required
              noStyle
            >
              <SelectItem sinBorde style={{ width: "100%" }} placeholder="Proyecto">
                {this.state.objetoProyectos}
              </SelectItem>
            </FormItem>
          </td>

          <td className="td-border">
            <FormItem {...restField} noStyle shouldUpdate>
               {({ getFieldValue }) => {
                let arrayValue = getFieldValue("insumos");
                let subProyectos = null
                if (arrayValue[arrayKey]?.proyectoId) {
                  const proyecto = this.state.todasProyectos.find(
                    (valueInsumos) => valueInsumos._id === arrayValue[arrayKey].proyectoId
                  );
                  if (proyecto && Array.isArray(proyecto?.subProyectos)) {
                    subProyectos = proyecto.subProyectos.map((value) => {
                      return (
                        <Option value={value._id} key={value._id}>
                          {value.nombre}
                        </Option>
                      );
                    });
                  } else {
                    subProyectos = null
                  }
                }
                if (subProyectos && subProyectos?.length > 0) {
                  return (
                    <FormItem
                      {...restField}
                      name={[name, "subProyectoId"]}
                      fieldKey={[arrayKey, "subProyectoId"]}
                      noStyle
                    >
                      <SelectItem
                        sinBorde
                        style={{ width: "100%" }}
                        placeholder="Subproyecto"
                      >
                        {subProyectos}
                      </SelectItem>
                    </FormItem>
                  );
                }
                return null;
              }}
            </FormItem>
          </td>
          <td className="td-border">
            <FormItem
              {...restField}
              name={[name, "precioUnitario"]}
              fieldKey={[arrayKey, "precioUnitario"]}
              noStyle
              required
              numberCero
            >
              <InputNumberItem
                sinBorde
                placeholder="Precio Unitario"
                onChange={(value) => this.onChangePrecioCantidadDescuento(value, arrayKey)}
                dinero
              />
            </FormItem>
          </td>
          {/* P.U. c/Imp. */}
          <td className="td-border">
            <FormItem {...restField} noStyle shouldUpdate>
              {({ getFieldValue }) => {
                const arrayValue = getFieldValue("insumos");
                let disabled = true;
                if (arrayValue[arrayKey]?.insumoId) {
                  const insumo = arrayValue[arrayKey].insumoCompleto;
                  disabled = !!insumo?.impuestos[0]?.combustible;
                }
                return (
                  <FormItem
                    name={[name, "precioUnitarioConImpuestos"]}
                    noStyle
                    required
                    numberCero
                    shouldUpdate
                  >
                    <InputNumberItem
                      sinBorde
                      disabled={disabled}
                      placeholder="Precio Unitario con Impuestos"
                      onChange={(value) => this.onChangePrecioImpuestos(value, arrayKey)}
                      dinero={!disabled}
                      dineroDisabled={disabled}
                    />
                  </FormItem>
                );
              }}
            </FormItem>
          </td>
          {/* Cant. */}
          <td className="td-border">
            <FormItem
              {...restField}
              name={[name, "cantidad"]}
              fieldKey={[arrayKey, "cantidad"]}
              required
              number
              noStyle
            >
              <InputNumberItem
                sinBorde
                placeholder="Cantidad"
                onChange={(value) =>
                   this.onChangePrecioCantidadDescuento(value, arrayKey)
                  }
              />
            </FormItem>
          </td>
          {/* Desc. */}
          <td className="td-border">
            <FormItem
              {...restField}
              name={[name, "descuento"]}
              fieldKey={[arrayKey, "descuento"]}
              required
              numberCero
              noStyle
              shouldUpdate
              initialValue={0}
            >
              <InputNumberItem
                sinBorde
                placeholder="Descuento"
                porcentaje
                max={100}
                onChange={(value) => this.onChangePrecioCantidadDescuento(value, arrayKey)}
              />
            </FormItem>
          </td>
       
        {/* Subtotal / Imp. / Total*/}
        <td className="td-border">
          <FormItem noStyle shouldUpdate>
            {({ getFieldValue }) => {
              const subtotal  = getFieldValue(["insumos", arrayKey, "subtotal"])  || 0;
              const total     = getFieldValue(["insumos", arrayKey, "total"])     || 0;
              let arrayValue = getFieldValue("insumos");
              let combustible = false;
              if (arrayValue[arrayKey]?.insumoId) {
                const insumo = arrayValue[arrayKey].insumoCompleto;
                combustible = !!insumo?.impuestos[0]?.combustible;
              }
              const impuestos = arrayValue[arrayKey]?.impuestos || 0;
              return (
                <div className="celda-totales" style={{ fontSize: "12px" }}>
                  <div>{dineroDisabledMask(subtotal)}</div>
                  {combustible ? (
                    <FormItem name={[name, "impuestos"]} required numberCero noStyle>
                      <InputNumberItem
                        sinBorde
                        dinero
                        placeholder="Impuestos (IEPS)"
                        onChange={(value) => this.onChangePrecioCantidadDescuento(value, arrayKey)}
                      />
                    </FormItem>
                  ) : (
                    <div>{dineroDisabledMask(impuestos)}</div>
                  )}
                  <div className="total-bold">Total: {dineroDisabledMask(total)}</div>
                </div>
              );
            }}
          </FormItem>

          <FormItem {...restField} name={[name, "subtotal"]} fieldKey={[arrayKey, "subtotal"]} required numberCero hidden>
            <InputNumberItem />
          </FormItem>

          {/* Hidden impuestos field when not combustible */}
          <FormItem {...restField} noStyle shouldUpdate>
            {({ getFieldValue }) => {
              let arrayValue = getFieldValue("insumos");
              let combustible = false;
              if (arrayValue[arrayKey]?.insumoId) {
                const insumo = arrayValue[arrayKey].insumoCompleto;
                combustible = !!insumo?.impuestos[0]?.combustible;
              }
              if (combustible) return null;
              return (
                <FormItem name={[name, "impuestos"]} required numberCero noStyle hidden>
                  <InputNumberItem />
                </FormItem>
              );
            }}
          </FormItem>

          <FormItem {...restField} name={[name, "total"]} fieldKey={[arrayKey, "total"]} required numberCero hidden>
            <InputNumberItem />
          </FormItem>

        </td>
        {/* Acción */}
        <td className="td-border-sin-right">
          <Row className="acciones-container">
            <Col span={24}>
              <Space
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center"
                }}
                size={4}
                className="acciones-container"
              >

                <FormItem noStyle shouldUpdate>
                  {({ getFieldValue }) => {
                    const arrayValue = getFieldValue("insumos");

                    let mostrarMarbetes = false;
                    let mostrarLotes = false;
                    let mostrarVehiculo = false;

                    if (arrayValue[arrayKey]?.insumoId) {
                      const insumo = arrayValue[arrayKey].insumoCompleto;
                      mostrarMarbetes = insumo?.marbetes;
                      mostrarLotes = insumo?.lotesCaducidades;
                      mostrarVehiculo = insumo?.vehiculo;
                    }

                    if (mostrarLotes) {
                      return (
                        <Tooltip title="Gestionar lotes" placement="top" overlayInnerStyle={{ fontSize: "10px" }}>
                          <ButtonItem
                            type="primary"
                            cyan2
                            icon={<DatabaseOutlined />}
                            size="small"
                            onClick={() => {
                              const insumoId = arrayValue[arrayKey]?.insumoCompleto?.insumoPrincipalId;
                              this.abrirAgregarLotes(
                                arrayKey,
                                arrayValue[arrayKey]?.lotes,
                                mostrarVehiculo,
                                insumoId
                              );
                            }}
                          >
                           {this.props.taxidermia ? "Animales" : "Lotes"}
                          </ButtonItem>
                        </Tooltip>
                      );
                    }

                    if (mostrarMarbetes) {
                      return (
                        <Tooltip title="Gestionar marbetes" placement="top" overlayInnerStyle={{ fontSize: "10px"}}>
                          <ButtonItem
                            type="primary"
                            amarillo2
                            icon={<TagsOutlined />}
                            size="small"
                            onClick={() =>
                              this.abrirAgregarMarbetes(
                                arrayKey,
                                arrayValue[arrayKey]?.marbetes
                              )
                            }
                          >
                          </ButtonItem>
                        </Tooltip>
                      );
                    }

                    return null;
                  }}
                </FormItem>

              <Tooltip title="Dividir insumo" placement="top" overlayInnerStyle={{ fontSize: "10px" }}>
                <ButtonItem
                  negro 
                  icon={<SplitCellsOutlined />}
                  onClick={() => this.abrirSplitInsumo(arrayKey)}
                  size="small"
                />
              </Tooltip>
               <Tooltip title="Eliminar" placement="top" overlayInnerStyle={{ fontSize: "10px" }}>
                <ButtonItem
                  rojo2
                  icon={<DeleteOutlined />}
                  onClick={() => remove(name)}
                  size="small"
                />
              </Tooltip>
             </Space>
            </Col>
          </Row>
        </td>
        </tr>
        {this.state.mostrarDetalles && (
          <FormItem
            noStyle
            shouldUpdate={(prevValues, currentValues) => {
              const prev = prevValues.insumos[arrayKey];
              const curr = currentValues.insumos[arrayKey];
              return (
                prev?.cantidad !== curr?.cantidad ||
                prev?.insumoId !== curr?.insumoId ||
                prev?.precioUnitario !== curr?.precioUnitario
              );
            }}
          >
            {({ getFieldValue }) => {
              const insumosArr = getFieldValue("insumos");
              const insumoData = insumosArr[arrayKey];
              const cantidad   = insumoData?.cantidad;
              const costo      = insumoData?.precioUnitario;
              const insumoId   = insumoData?.insumoId;
              const insumo     = insumoData?.insumoCompleto;
              if (!insumo) return null;
              return (
                <InsumoDetalleRow
                  insumo={insumo}
                  cantidad={cantidad}
                  costo={costo}
                  colSpans={{ details: 5, projection: 2, filler: 4 }}
                  onCloseModal={async () => {
                    const currentProveedorId = this.formRef.current.getFieldValue("proveedorId");
                    await this.recargarInsumoEditado(currentProveedorId, insumoId, arrayKey);
                  }}
                />
              );
            }}
          </FormItem>
        )}
      </React.Fragment>
    );
  }

  getObservacionesConfig() {
    return {
      totales: (
        <FormItem shouldUpdate noStyle>
          {({ getFieldValue }) => {
            let arrayInsumos = Array.isArray(getFieldValue("insumos")) ? getFieldValue("insumos") : [];
            let ajusteSubtotal =
              getFieldValue("ajusteSubtotal") || 0;
            let arrayRetenciones = [];
            let cuentasProveedor = 0;
            let subtotal = 0;
            let subtotalVI = 0;
            let arrayImpuestos = [];
            let total = 0;
            arrayInsumos.map((value) => {
              if (value) {
                if (
                  value.subtotal &&
                  value.total &&
                  value.arrayImpuestos
                ) {
                  subtotal += value.subtotal;
                  subtotalVI += value.subtotal;
                  total += value.subtotal;
                  value.arrayImpuestos.map((valueImpuestos) => {
                    let index = arrayImpuestos.findIndex(
                      (valueImpuestosAnterios) =>
                        valueImpuestosAnterios.descripcionFactura ===
                        valueImpuestos.descripcionFactura
                    );
                    if (index !== -1) {
                      let newItem = {
                        totalImpuestos:
                          arrayImpuestos[index].totalImpuestos +
                          valueImpuestos.totalImpuestos,
                        descripcionFactura:
                          valueImpuestos.descripcionFactura,
                      };
                      arrayImpuestos.splice(index, 1, newItem);
                    } else {
                      arrayImpuestos.push({
                        totalImpuestos:
                          valueImpuestos.totalImpuestos,
                        descripcionFactura:
                          valueImpuestos.descripcionFactura,
                      });
                    }
                    return null;
                  });
                  if (value.arrayRetenciones) {
                    value.arrayRetenciones.map(
                      (valueRetenciones) => {
                        let index = arrayRetenciones.findIndex(
                          (valueRetencionesAnterios) =>
                            valueRetencionesAnterios.descripcionFactura ===
                            valueRetenciones.descripcionFactura
                        );
                        cuentasProveedor += round2Decimals(
                          valueRetenciones.totalRetenciones
                        );
                        if (index !== -1) {
                          let newItem = {
                            totalRetenciones:
                              arrayRetenciones[index]
                                .totalRetenciones +
                              valueRetenciones.totalRetenciones,
                            descripcionFactura:
                              valueRetenciones.descripcionFactura,
                          };
                          arrayRetenciones.splice(
                            index,
                            1,
                            newItem
                          );
                        } else {
                          arrayRetenciones.push({
                            totalRetenciones:
                              valueRetenciones.totalRetenciones,
                            descripcionFactura:
                              valueRetenciones.descripcionFactura,
                          });
                        }
                        return null;
                      }
                    );
                  }
                }
              }
              return null;
            });
            subtotal += ajusteSubtotal;
            total += ajusteSubtotal;
            arrayImpuestos = arrayImpuestos.map((valueImpuesto) => {
              let ajusteImpuesto =
                getFieldValue(
                  "ajuste" + valueImpuesto.descripcionFactura
                ) || 0;
              total += round2Decimals(
                valueImpuesto.totalImpuestos + ajusteImpuesto
              );
              return {
                ...valueImpuesto,
                totalImpuestos: round2Decimals(
                  valueImpuesto.totalImpuestos + ajusteImpuesto
                ),
                totalImpuestosVI: valueImpuesto.totalImpuestos,
              };
            });
            arrayRetenciones = arrayRetenciones.map(
              (valueRetencion) => {
                let ajusteRetencion =
                  getFieldValue(
                    "ajuste" + valueRetencion.descripcionFactura
                  ) || 0;
                cuentasProveedor += ajusteRetencion;
                return {
                  ...valueRetencion,
                  totalRetenciones:
                    valueRetencion.totalRetenciones +
                    ajusteRetencion,
                  totalRetencionesVI:
                    valueRetencion.totalRetenciones,
                };
              }
            );                 
            return (
              <table className="table totales-table" style={{ borderCollapse: "collapse", width: "100%", margin: 0 }}>
                <tbody>
                  <tr>
                    <th className="td-totales-center" style={{ width: "25%"}}></th>
                    <td className="td-totales-center" style={{ width: "15%"}}>
                        <Tag style={{ backgroundColor: "#f5f5f5",borderColor: "#d9d9d9", color: "#595959",fontWeight: 600, padding: "2px 50px",borderRadius: "6px"
                        }}
                      >
                        Ajuste
                      </Tag>
                    </td>
                    <td className="td-totales-center" style={{ width: "25%" }}></td>
                    </tr>
                  <tr>
                    <th className="th-totales" style={{ width: "25%" }}>Subtotal: </th>
                    <td className="td-totales-right" style={{ width: "25%" }}>
                      <FormItem
                        name="ajusteSubtotal"
                        numberNegativo
                        noStyle
                        max={this.state.ajusteMax}
                        min={Math.max(-this.state.ajusteMax, -subtotalVI)}
                        type="number"
                        required
                        initialValue={0}
                      >
                        <InputNumberItem step={0.01} sinBorde dinero precision={2} placeholder={"Max: ±" + this.state.ajusteMax} />
                      </FormItem>
                    </td>
                    <td className="td-totales-right" style={{ width: "25%" }}>
                      {dineroDisabledMask(subtotal)}
                    </td>
                  </tr>
                </tbody>
                {arrayImpuestos.map((valueArray) => (
                  <tbody key={valueArray.descripcionFactura}>
                      <tr>
                        <th
                          className="th-totales"
                          style={{ width: "25%" }}
                        >
                          {valueArray.descripcionFactura}
                        </th>
                        <td
                          className="td-totales-right"
                          style={{
                            width: "25%",
                          }}
                        >
                          <FormItem
                            name={
                              "ajuste" + valueArray.descripcionFactura
                            }
                            numberNegativo
                            noStyle
                            max={this.state.ajusteMax}
                            min={Math.max(
                              -this.state.ajusteMax,
                              -valueArray.totalImpuestosVI
                            )}
                            type="number"
                            required
                            initialValue={0}
                            precision={2}
                          >
                            <InputNumberItem
                              step={0.01}
                              sinBorde
                              dinero
                              placeholder={
                                "Max: ±" + this.state.ajusteMax
                              }
                            />
                          </FormItem>
                        </td>
                        <td
                          className="td-totales-right"
                        >
                          {dineroDisabledMask(
                            valueArray.totalImpuestos
                          )}
                        </td>
                        </tr>
                  </tbody>
                ))}
                <tbody>
                  <tr>
                    <th
                      className="th-totales"
                      style={{ width: "25%" }}
                    >
                      Total:
                    </th>
                    <td
                      className="td-totales-right"
                      style={{
                        width: "25%",
                      }}
                    ></td>
                    <td
                      className="td-totales-right"
                      style={{
                        width: "25%",
                      }}
                    >
                      {dineroDisabledMask(total)}
                    </td>
                    </tr>
                </tbody>
                {arrayRetenciones.map((value) => (
                  <tbody key={value.descripcionFactura}>
                    <tr>
                      <th
                        className="th-totales"
                        style={{ width: "25%" }}
                      >
                        {value.descripcionFactura}
                      </th>
                      <td
                        className="td-totales-right"
                        style={{
                          width: "25%",
                        }}
                      >
                        <FormItem
                          name={"ajuste" + value.descripcionFactura}
                          numberNegativo
                          noStyle
                          max={this.state.ajusteMax}
                          min={Math.max(
                            -this.state.ajusteMax,
                            -value.totalRetencionesVI
                          )}
                          type="number"
                          required
                          initialValue={0}
                          precision={2}
                        >
                          <InputNumberItem
                            step={0.01}
                            sinBorde
                            dinero
                            placeholder={
                              "Max: ±" + this.state.ajusteMax
                            }
                          />
                        </FormItem>
                      </td>
                      <td
                        className="td-totales-right"
                      >
                        {dineroDisabledMask(value.totalRetenciones)}
                      </td>
                      </tr>
                  </tbody>
                ))}
                <tbody>
                  <tr>
                    <th
                      className="th-totales"
                      style={{ width: "25%" }}
                    >
                      Total a pagar:
                    </th>
                    <td
                      className="td-totales-right"
                      style={{
                        width: "25%",
                      }}
                    ></td>
                    <td
                      className="td-totales-right"
                    >
                      {dineroDisabledMask(total - cuentasProveedor)}
                    </td>
                  </tr>
                </tbody>
              </table>
            );
          }}
        </FormItem>
      ),
    };
  }

  render() {
    const isMobile = window.innerWidth < 1000;
    return (
      <>
        <PageHeader
          onBack={this.atras.bind(this)}
          title="Remisión"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            <Space>
              <ButtonItem blanco onClick={this.actualizarBoton.bind(this)}>
                Actualizar Informacion
              </ButtonItem>
            </Space>
          }
        />
        <div className="card-background">
          <Spin spinning={this.state.loading}>
            <Form
              ref={this.formRef}
              name="agregarRemision"
              layout
              onFinish={(values) =>
                this.setState({ modalConfirmacion: true, valuesForm: values })
              }
              onFinishFailed={this.onFinishFailed}
            >
              <GeneralFormLayout
                isMobile={isMobile}
                cards={[
                  {
                    title: "Datos Generales",
                    lg: 15,
                    xl: 15,
                    content: (
                      <Row gutter={[16, 0]}>
                        <Col xs={24} sm={24} lg={16} xl={16}>
                          <FormItem
                            label="Proveedor"
                            name="proveedorId"
                            margin
                            required
                            labelCol={{ span: 7 }}
                            wrapperCol={{ span: 16 }}
                          >
                            <SelectItem
                              placeholder="Proveedor"
                              onChange={this.onChangeProveedor.bind(this)}
                            >
                              {this.state.objetoProveedores}
                            </SelectItem>
                          </FormItem>
                          {this.state.proveedorId && (
                            <Row justify="center">
                              <Tooltip title="Asignar un nuevo insumo al proveedor seleccionado.">
                                <ButtonItem
                                  style={{ marginTop: 5, marginBottom: 10, width: "auto" }}
                                  type="primary"
                                  onClick={this.abrirModalAsignarInsumo}
                                  icon={<PlusOutlined />}
                                  cyan
                                  hotkey="alt+n"
                                >
                                  Asignar Nuevo Insumo
                                </ButtonItem>
                              </Tooltip>
                            </Row>
                          )}
                        </Col>

                        <Col xs={24} sm={24} lg={6} xl={6} style={{ textAlign: "center", justifyContent: "center" }}>
                          <FormItem shouldUpdate noStyle>
                            {({ getFieldValue }) => {
                              const proveedorId = getFieldValue("proveedorId");
                              if (!proveedorId) return null;

                              const proveedor = this.state.todasProveedores.find((v) => v._id === proveedorId);

                              return (
                                <div style={{ textAlign: "center" }}>
                                  <p style={{ margin: 0 }}>
                                    RFC:{" "}
                                    <Tag color="default" style={{ fontWeight: "bold" }}>
                                      {proveedor.rfc}
                                    </Tag>
                                  </p>
                                </div>
                              );
                            }}
                          </FormItem>
                        </Col>
                        <Col xs={24} sm={24} lg={22} xl={22}>
                          <FormItem
                            label="Proyecto"
                            name="proyectoId"
                            labelCol={{ span: 5 }}
                            wrapperCol={{ span: 18 }}
                            margin
                            required
                          >
                            <SelectItem
                              placeholder="Proyecto"
                              onChange={(value) => this.onChangeProyecto(value)}
                            >
                              {this.state.objetoProyectos}
                            </SelectItem>
                          </FormItem>
                          {this.state.proyectosConSubproyectos && (
                            <FormItem shouldUpdate noStyle>
                              {({ getFieldValue }) => {
                                const proyectoId = getFieldValue("proyectoId");
                                if (!proyectoId) return null;
                                return (
                                  <FormItem
                                    label="Subproyecto"
                                    name="subProyectoId"
                                    labelCol={{ span: 6 }}
                                    wrapperCol={{ span: 18 }}
                                    margin
                                  >
                                    <SelectItem placeholder="Subproyecto" allowClear>
                                      {this.state.objetoSubproyectos}
                                    </SelectItem>
                                  </FormItem>
                                );
                              }}
                            </FormItem>
                          )}
                        </Col>
                      </Row>
                    ),
                  },
                  {
                    title: "Moneda",
                    lg: 9,
                    xl: 9,
                    content: (
                      <Row gutter={[16, 0]}>
                        <Col xs={24} sm={24} lg={12} xl={12}>
                          <FormItem
                            label="Moneda"
                            name="monedaId"
                            margin
                            required
                            initialValue="60c7e4396465ad440c41c15a"
                            labelCol={{ span: 8 }}
                            wrapperCol={{ span: 16 }}
                          >
                            <SelectItem
                              placeholder="Moneda"
                              onChange={(value) => {
                                if (value === "60c7e4396465ad440c41c15a") {
                                  this.formRef.current.setFieldsValue({ tipoDeCambio: 1 });
                                }
                              }}
                            >
                              {this.state.objetoMonedas}
                            </SelectItem>
                          </FormItem>
                        </Col>
                        <Col xs={24} sm={24} lg={12} xl={12}>
                          <FormItem shouldUpdate noStyle>
                            {({ getFieldValue }) => {
                              const monedaId = getFieldValue("monedaId");
                              return (
                                <FormItem
                                  label="Tipo de Cambio"
                                  name="tipoDeCambio"
                                  margin
                                  initialValue={1}
                                  labelCol={{ span: 11 }}
                                  wrapperCol={{ span: 13 }}
                                >
                                  <InputNumberItem
                                    disabled={monedaId === "60c7e4396465ad440c41c15a"}
                                    placeholder="Tipo de Cambio"
                                  />
                                </FormItem>
                              );
                            }}
                          </FormItem>
                        </Col>
                      </Row>
                    ),
                  },
                  {
                    title: "Datos Remisión",
                    lg: 24,
                    xl: 24,
                    content: (
                      <Row gutter={[16, 0]}>
                        <Col xs={24} sm={24} lg={8} xl={8}>
                          <FormItem name="codigoRemision" label="Serie y Folio" margin pattern>
                            <InputItem placeholder="Serie y Folio" />
                          </FormItem>
                        </Col>
                         <Col xs={24} sm={24} lg={6} xl={6}>
                          <FormItem label="Días de Crédito" name="diasCredito" required numberCero margin
                            labelCol={{ span: 10 }}
                            wrapperCol={{ span: 12 }}
                          >
                            <InputNumberItem
                              placeholder="Días de Crédito"
                              onChange={(value) => {
                                const fechaRemision = this.formRef.current.getFieldValue("fechaRemision");
                                this.formRef.current.setFieldsValue({
                                  fechaPago: moment(fechaRemision).add(value, "days"),
                                });
                              }}
                            />
                          </FormItem>
                        </Col>
                       
                        <Col xs={24} sm={24} lg={8} xl={8}>
                          <FormItem label="Fecha de Remisión" name="fechaRemision" required margin>
                            <DatePickerItem
                              placeholder="Fecha de Remisión"
                              allowClear={false}
                              onChange={(value) => {
                                const fechaRemision = moment(value);
                                const diasCredito = this.formRef.current.getFieldValue("diasCredito");
                                this.formRef.current.setFieldsValue({
                                  fechaPago: fechaRemision.add(diasCredito, "days"),
                                });
                              }}
                            />
                          </FormItem>
                        </Col>
                       
                        <Col xs={24} sm={24} lg={6} xl={6}>
                          <FormItem
                            label="Fecha Probable de Pago"
                            name="fechaPago"
                            required
                            margin
                            labelCol={{ span: 10 }}
                            wrapperCol={{ span: 12 }}
                          >
                            <DatePickerItem
                              placeholder="Fecha Probable de Pago"
                              allowClear={false}
                              onChange={(value) => {
                                const fechaRemision = moment(this.formRef.current.getFieldValue("fechaRemision"));
                                const diferencia = value.diff(fechaRemision, "days") + 1;
                                this.formRef.current.setFieldsValue({ diasCredito: diferencia });
                              }}
                            />
                          </FormItem>
                        </Col>
                         <Col xs={24} sm={24} lg={9} xl={9}>
                          <FormItem name="descripcion" label="Descripción" margin pattern>
                            <InputItem placeholder="Descripción" />
                          </FormItem>
                        </Col>
                      </Row>
                    ),
                  },
                ]}
                tabsConfig={{
                  tabs: [
                    {
                      key: "insumos",
                      label: "Insumos",
                      listName: "insumos",
                      columns: this.getInsumosColumns(),
                      renderRow: this.renderInsumoRow.bind(this),
                      renderHeader: ({ fields, add }) => (
                        <Row justify="space-between" align="middle" style={{ marginBottom: 4 ,  marginRight: "15px" }}>
                          <Col>
                            <FormItem
                              name="recibirInsumos"
                              label="Recibir Insumos"
                              margin
                              valuePropName="checked"
                              initialValue={true}
                              style={{ marginBottom: 0 }}
                              labelCol={{ span: 21 }}
                              wrapperCol={{ span: 3 }}
                            >
                              <Checkbox />
                            </FormItem>
                          </Col>
                          <Col>
                            <Space>
                              <Typography.Text style={{ fontSize: "12px", color: "#888" }}>
                                Mostrar detalles:
                              </Typography.Text>
                              <Switch
                                size="small"
                                checked={this.state.mostrarDetalles}
                                onChange={(checked) => this.setState({ mostrarDetalles: checked })}
                              />
                            </Space>
                          </Col>
                        </Row>
                      ),
                      renderFooter: ({ add, fields }) => (
                        <FormItem noStyle>
                          <ButtonItem
                            style={{
                              marginTop: 10,
                              marginBottom: 10,
                              justifySelf: fields.length > 0 ? "left" : null,
                              width: fields.length > 0 ? "auto" : null,
                            }}
                            type="primary"
                            onClick={() => add()}
                            block
                            cyan
                            icon={<PlusOutlined />}
                            hotkey="alt+a"
                          >
                            Agregar Insumo
                          </ButtonItem>
                        </FormItem>
                      ),
                    },
                  ],
                  isMobile,
                  formInstance: this.formRef,
                }}
                observacionesConfig={this.getObservacionesConfig()}
                actionButtons={
                  <ButtonItem
                    type="primary"
                    htmlType="submit"
                    cyanB
                    style={{ width: "5%" }}
                    hotkey="shift+r"
                  >
                    Recibir
                  </ButtonItem>
                }
              />
            </Form>
          </Spin>
        </div>
        <ModalItem
          title="Confirmacion"
          visible={this.state.modalConfirmacion}
          onCancel={() => this.setState({ modalConfirmacion: false })}
          onOk={() => {
            this.setState({ modalConfirmacion: false });
            this.onFinish(this.state.valuesForm);
          }}
          spinning={false}
          footer
        >
          <h1 style={{ textAlign: "center" }}>Desea continuar</h1>
        </ModalItem>
        <ElegirTipoDeProveedor
          visible={this.state.modalElegirTipoDeProveedor}
          id={this.state.modalElegirTipoDeProveedorId}
          nombre={this.state.modalElegirTipoDeProveedorNombre}
          cerrarElegirTipoDeProveedor={this.cerrarElegirTipoDeProveedor.bind(
            this
          )}
        />
        <AgregarMarbetes
          visible={this.state.modalAgregarMarbetes}
          cerrarAgregarMarbetes={this.cerrarAgregarMarbetes.bind(this)}
          marbetes={this.state.modalAgregarMarbetesMarbetes}
        />
        <AgregarLotes
          visible={this.state.modalAgregarLotes}
          cerrarAgregarLotes={this.cerrarAgregarLotes.bind(this)}
          lotes={this.state.modalAgregarLotesLotes}
          vehiculo={this.state.modalAgregarLotesVehiculo}
          insumoId = { this.state.modalAgregarLotesInsumoId}
        />
        <ModalSplitInsumo
          visible={this.state.modalSplitVisible}
          onCancel={() => this.setState({ modalSplitVisible: false })}
          onOk={(partidas) => this.confirmarSplitInsumo(partidas)}
          proyectos={this.state.todasProyectos} // mismo arreglo que ya usas
          insumo={this.state.modalSplitInsumo} // insumo seleccionado
          cantidad={this.state.modalSplitCantidad} // cantidad a dividir
        />
        <AsignarInsumo
          visible={this.state.modalAsignarInsumoVisible}
          cerrarAsignarInsumo={this.cerrarModalAsignarInsumo}
          proveedor={this.state.proveedorSeleccionado}
          empresaId={this.props.empresaId}
          headersToken={this.props.headersToken}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    taxidermia: state.empresa.taxidermia,
  };
};

export default connect(mapStateToProps)(AgregarRemision);
